import React, { useState } from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import TableIconModalWithTwoHandle from "../../../shares/TableIconModalWithTwoHandle";

const ChangeOrderState = (props) => {
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);

  // const createLog = useFetch({
  //   method: "post",
  //   url: `Order_Service/${props.selectedRow?.id}/create_order_log`,
  //   data: { state: "order_change_state" },
  //   argFunc: (res) => {},
  //   errMessage: (mess) => {},
  // });

  const updateOrderApi = useFetch({
    method: "post",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/admin_confirmed_provider_deliverd`,
    trigger: false,
    // data: { state: "onprogress" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      // createLog.reFetch();
      setOpenModal(false);
      props.adminGetCustomerReceviedOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const rejectOrderApi = useFetch({
    method: "patch",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/admin_reject_provider_order_from_complete_to_onprogress`,
    trigger: false,
    // data: { state: "onprogress" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      // createLog.reFetch();
      setOpenModal(false);
      props.adminGetCustomerReceviedOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const provider_change_order_to_waiting = () => {
    updateOrderApi.reFetch();
  };

  const provider_change_order_to_reject = () => {
    rejectOrderApi.reFetch();
  };

  return (
    <>
      <TableIconModalWithTwoHandle
        width="w-2/5"
        isRemove={true}
        removeText="آیا از تایید سفارش  اطمینان دارید؟"
        icon={<ImportExportIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={provider_change_order_to_waiting}
        handleNoOnClick={provider_change_order_to_reject}
      ></TableIconModalWithTwoHandle>
    </>
  );
};

export default ChangeOrderState;
